import {RestResource} from "@/api/rest";
import {merge} from "@/util";
import {HeaderBuilder} from "@/util/athub-axios/header";

export const getBillingAthubConfig = (athubConfig, billingAuthorizes) => {
    return merge(true, {}, HeaderBuilder.getHeadersByBilling(billingAuthorizes), athubConfig);
};

export class BillRestResource extends RestResource {
    constructor({server, resource}) {
        super({server, resource});
    }

    getAll (athubConfig) {
        return super.getAll(getBillingAthubConfig(athubConfig));
    }

    add (model, athubConfig) {
        return super.add(model, getBillingAthubConfig(athubConfig));
    }

    batchAdd (models, athubConfig) {
        return super.batchAdd(models, getBillingAthubConfig(athubConfig));
    }

    get (id, athubConfig) {
        return super.get(id, getBillingAthubConfig(athubConfig));
    }

    update (id, model, athubConfig) {
        return super.update(id, model, getBillingAthubConfig(athubConfig));
    }

    delete (id, athubConfig) {
        return super.delete(id, getBillingAthubConfig(athubConfig));
    }

    list (search, athubConfig) {
        return super.list(search, getBillingAthubConfig(athubConfig));
    }

    page (pageSearch, athubConfig) {
        return super.page(pageSearch, getBillingAthubConfig(athubConfig));
    }

    count (search, athubConfig) {
        return super.count(search, getBillingAthubConfig(athubConfig));
    }
}